"use strict";

exports.__esModule = true;
exports.logger = void 0;
var logger = console;
exports.logger = logger;